var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticStyle:{"min-width":"600px","width":"800px","height":"300px","overflow":"hidden"},attrs:{"column":""}},[_c('div',{ref:"chartdiv",staticClass:"stream-graph"})])}
var staticRenderFns = []

export { render, staticRenderFns }